var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-datepicker',{attrs:{"placeholder":"Selecione a data","icon":"calendar-today","trap-focus":"","value":_vm.date,"month-names":_vm.nomesMeses,"position":_vm.position,"years-range":_vm.yearsRange,"type":"month","editable":"","locale":"pt-BR"},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }